@use "./breakpoint.module.scss" as *;

.pdp {
    --scroll-nav-menu-block-height: 72px;

    @media ($below-mobile) {
        --scroll-nav-menu-block-height: 60px;
    }
}
